export default __webpack_public_path__ + "static/media/CommissionsStub.b948c1b4.svg";